import { GenericBackendResponse } from '../genericBackendResponse';
import { HoldedInvoice } from './HoldedInvoice';

const getHoldedInvoices = async (
	token: string,
	companyId: string
): Promise<GenericBackendResponse<{ documents: HoldedInvoice[]; total: number }>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/holded/invoices/${companyId}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	return response.json();
};

export default getHoldedInvoices;
